import { useState } from "react";
import { useSnackbar } from 'notistack';
// @mui
import {
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// hooks
import useResponsive from '../../../../hooks/useResponsive';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import useAuth from '../../../../hooks/useAuth';
// components
import Label from '../../../../components/Label';
import {
  PositionLabel,
} from "../../";
// util
import axios from '../../../../utils/axios';

// ----------------------------------------------------------------------

export default function SetExternalLinkForm({ jobPost, next, isEdit }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const [externalLink, setExternalLink] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const postExternalLink = async () => {
    setIsSubmitting(true);
    try {
      const companyId = user?.employee.company[0].id;
      const response = await axios.post(`/api/company/${companyId}/job-posts/${jobPost.id}/external-link/`, {
        external_link: externalLink,
      });
      if (smUp) {
        enqueueSnackbar('저장되었습니다');
      } else {
        enqueueSnackbar('저장되었습니다', {anchorOrigin: { vertical: 'bottom', horizontal: 'center' }});
      }
      await next(jobPost.id);
      if (isMountedRef.current) {
        setIsSubmitting(false);
      }
    } catch (err) {
      setIsSubmitting(false);
      console.error(err);
      enqueueSnackbar('저장에 실패했습니다. 다시 시도해주세요.', { variant: "error" });
    }
  }

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1 }}>
        <Label variant="outlined" color="secondary" sx={{ borderRadius: 2}}>
          #원격 근무
        </Label>
        <Label variant="outlined" color="secondary" sx={{ borderRadius: 2}}>
          #파트타임
        </Label>
        <Label variant="outlined" color="secondary" sx={{ borderRadius: 2}}>
          #4주 단위
        </Label>
      </Stack>
      <Stack direction="row" alignItems="center" sx={{ mb: 1 , flexWrap: 'wrap', gap: smUp ? 1 : 0.5 }}>
        <Typography variant="h4">
          다른 사이트에 올려둔
        </Typography>
        <PositionLabel position={jobPost?.position} detailRole={jobPost?.detail_role} aiSelected={jobPost?.select_ai_position} />
        <Typography variant="h4">
          채용 공고 링크를 알려주세요.
        </Typography>
      </Stack>

      <Typography variant={smUp ? "body1" : "body2"} sx={{ wordBreak: "keep-all" }}>
        원티드, 노션, 그리팅, 사람인, 로켓펀치 등에 올려두신 채용 공고 링크가 있다면 복사해서 붙여 넣어 주세요.
      </Typography>

      <Stack sx={{ mt: { xs: 4, sm: 5 }, mb: { xs: 6, sm: 7 }}} spacing={1}>
        <Typography variant={smUp ? "subtitle1" : "subtitle2"}>
          채용 공고 링크
        </Typography>
        <TextField
          fullWidth
          value={externalLink}
          onChange={(e) => setExternalLink(e.target.value)}
          placeholder="채용 공고 링크 URL을 붙여 넣어 주세요"
        />
      </Stack>

      <LoadingButton
        variant="contained"
        size="large"
        disabled={!externalLink}
        loading={isSubmitting}
        onClick={postExternalLink}
      >
        완료
      </LoadingButton>
    </>
  )
}